import PropTypes from 'prop-types';
import postsStrings from 'modules/posts/strings';

import { Wrapper, AddRssFeedBtn } from './RssFeedHeader.style';

const RssFeedHeader = ({ handleAddRssFeedBtnClick }) => (
  <Wrapper>
    <AddRssFeedBtn as="button" onClick={handleAddRssFeedBtnClick}>
      {postsStrings.rssFeedHeader.addRssFeedBtn}
    </AddRssFeedBtn>
  </Wrapper>
);

RssFeedHeader.propTypes = {
  handleAddRssFeedBtnClick: PropTypes.func.isRequired,
};

export default RssFeedHeader;
